<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml" xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-back="false" :has-nav="false">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px)">
      <div class="m-auto m-b-5 p-h-40 p-t-20"
           style="min-height: calc(100% - 5px);background-color: white">
        <div class="p-v-20">
          <Table :columns="columns" :data="getBarData" class="tablePtye">
            <template v-slot:dIcon="{row,index}">
              <div class="flex a-center j-center">
                <div @click="onPicChooseClick(row)" style="width: 40px;height: 40px">
                  <!--<up-load-image @uploadSuccess="uploadDefaultImageSuccess($event,index)"-->
                  <!--accept="image/*"-->
                  <!--picurl="company/about/"-->
                  <!--style="width: 40px;height: 40px">-->
                  <!--<template v-slot:tip>-->
                  <img src="../../../assets/common/ic_default_img.png"
                       style="width: 40px;height: 40px;cursor: pointer"
                       v-if="!row.iconUrl">
                  <img :src="row.iconUrl" style="width: 40px;height: 40px;cursor: pointer"
                       v-if="row.iconUrl">
                  <!--</template>-->
                  <!--</up-load-image>-->
                </div>
              </div>
            </template>
            <template v-slot:sIcon="{row,index}">
              <div class="flex a-center j-center">
                <div @click="onPicChooseClick(row)" style="width: 40px;height: 40px">
                  <!--<up-load-image @uploadSuccess="uploadSelectClassImageSuccess($event,index)" accept="image/*"-->
                  <!--picurl="company/about/" style="width: 40px;height: 40px">-->
                  <!--<template v-slot:tip>-->
                  <img src="../../../assets/common/ic_default_img.png"
                       style="width: 40px;height: 40px;cursor: pointer" v-if="!row.iconSelUrl">
                  <img :src="row.iconSelUrl" style="width: 40px;height: 40px;cursor: pointer" v-if="row.iconSelUrl">
                  <!--</template>-->
                  <!--</up-load-image>-->
                </div>
              </div>
            </template>
            <template v-slot:copy="{row,index}">
              <div class="flex a-center">
                <div class=" icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"
                     v-clipboard:copy="row.linkurl"
                     v-clipboard:error="onError"
                     v-clipboard:success="copy"/>

              </div>
            </template>
            <template v-slot:status="{row,index}">
              <div class="flex a-center">
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #EEFFEF;color: #4CAF50;border-radius: 11px;" v-if="row.status === 1">
                  已发布
                </div>
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #FFF3EB;color: red;border-radius: 11px;" v-if="row.status !== 1">
                  未发布
                </div>
                <!--<div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"-->
                <!--style="background-color: #FFF3EB;color: #FF6D00;border-radius: 11px;" v-if="row.isDefault === 1">-->
                <!--首页-->
                <!--</div>-->
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #FFF3EB;color: #FF6D00;border-radius: 11px;" v-if="row.type === 4">
                  官网
                </div>
              </div>
            </template>
            <template v-slot:operation="{row,index}">
              <div class="flex a-center fs-12">
                <!--弹窗页面标题-->
                <span @click="onRenameClick(row)" class="m-r-30" style="color:#3B80FF;cursor: pointer">重设名称</span>

                <span :style="{color:getStatus(row)}" @click="changeStatus(row,index)" class="m-r-40"
                      style="cursor: pointer"
                      v-if="row.type !== 7">{{ row.status === 1 ? '停用' : '发布' }}</span>
              </div>
            </template>
          </Table>
        </div>
      </div>
    </div>

    <!--重置名称弹框-->
    <Modal :closable="false" class="modal-setting" title=" " v-model="renameModal.show" width="400px">
      <p class="text-center" slot="header">
        <span>重置名称</span>
      </p>
      <div>
        <div class="w-full">
          <Input :maxlength="5" class="m-b-10" maxlength="5" show-word-limit style="width: 320px"
                 v-model="renameModal.name"/>
        </div>
        <div class="w-full">
          <div class="m-t-15 flex a-center fs-16 bold">
            <img class="w-20 h-20" src="../../../assets/common/ic_zujian.png">
            <div class="m-l-10" style="color:#007AFF">菜单字体</div>
          </div>
          <div class="flex a-center m-l-20 m-t-10">
            <div class="text-left m-h-10  fs-14 flex a-center">
              <div class="flex-s-0">选前颜色：</div>
              <div class="border m-l-10 text-center" style="width: 100px;height: 30px;line-height: 30px">
                {{renameModal.nameColor}}
              </div>
              <ColorPicker class="m-l-10" recommend
                           v-model="renameModal.nameColor"/>
            </div>
          </div>
          <div class="flex a-center m-l-20 m-t-10">
            <div class="text-left m-h-10  fs-14 flex a-center">
              <div class="flex-s-0">选后颜色：</div>
              <div class="border m-l-10 text-center" style="width: 100px;height: 30px;line-height: 30px">
                {{renameModal.nameSelectedColor}}
              </div>
              <ColorPicker class="m-l-10" recommend
                           v-model="renameModal.nameSelectedColor"/>
            </div>
          </div>
          <div class="flex a-center text-left m-l-20 m-t-10">
            <div class="text-left m-h-10  fs-14 flex a-center">
              <div class="flex-s-0">字号设置：</div>
              <RadioGroup v-model="renameModal.fontSize">
                <Radio :label="24" class="m-l-10 fs-14">小号</Radio>
                <Radio :label="28" class="m-l-10 fs-14">中号</Radio>
                <Radio :label="32" class="m-l-10 fs-14">大号</Radio>
              </RadioGroup>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full flex j-center" slot="footer">
        <Button @click="renameModalCancel">取消</Button>
        <Button @click="renameModalOk" style="margin-left: 50px" type="primary">确定</Button>
      </div>
    </Modal>

    <!--风格装修-->
    <Modal :closable="false" :mask-closable="false" @on-visible-change="onModalClose" class="modals"
           class-name="vertical-center-modal" footer-hide v-model="showStyleSet" width="680">
      <style-page-setting-widget :editData='editStyleData' @cancel="showStyleSet=false"
                                 @config="onStylePageOK ">
      </style-page-setting-widget>
    </Modal>

    <!--    分享设置弹框-->
    <Modal :closable="false" :mask-closable="false" @on-visible-change="onModalClose" class="modals"
           class-name="vertical-center-modal" footer-hide v-model="shareModal" width="550">
      <share-page-setting-widget :editData="editShareData" @cancel="shareModal=false"
                                 @config="onShareConfigOK"></share-page-setting-widget>
    </Modal>

    <!--企业编辑-->
    <Modal :closable="false" :mask-closable="false" class="modal-setting modal-setting2" footer-hide
           title=""
           v-model="companyModal.show" width="680px">
      <ent-edit-widget :entInfo="entInfo" @cancel="companyModal.show=false"
                       @ok="companyModal.show = false"></ent-edit-widget>
    </Modal>

    <Modal :closable="false" :mask-closable="false" class="modal-setting modal-setting2" footer-hide
           v-model="showPicChoose" width="380">
      <pic-choose-widget :editPicData="editPicData" @cancel="showPicChoose=false"
                         @ok="onIconOKClick"></pic-choose-widget>
    </Modal>

    <!--企业码下载-->
    <Modal
      class-name="vertical-center-modal"
      footer-hide
      v-model="showQrCode"
      width="550">
      <div class="flex-row" style="border: 1px solid #D1D2D3;  margin: 20px;">
        <div class="flex-column" style="width:90%;flex-shrink: 0;">
          <p class="modal-content-title fz-18 color-33 margin-top-20" style="word-break: break-all">企业码：<span>{{getEntname}}</span>&nbsp;&nbsp;
          </p>
          <img :src="getQrCode" alt="" class=" margin-top-20"
               style="width: 180px; height: 180px;">
          <div
            class="flex-row m-t-20"
            style="margin-bottom: 30px;width: 143px;height:33px ;border-radius: 3px;border:1px solid #67B3FF;background-color:#E6F1FC;cursor: pointer">
            <img alt="" src="../../../assets/common/ic_xiazai@2x.png" style="width:15px;height: 14px; ">
            <div @click="onQrcodeDownload" style="color:#1989FA;font-size: 14px;margin-left: 5px">立即下载</div>
          </div>
        </div>
      </div>
    </Modal>
  </base-page-component>
</template>

<script>
import BasePageComponent from '../../../components/common/BasePageComponent'
import UpLoadImage from '../../../components/common/UpLoadImage'
import {mapActions} from 'vuex'
import StylePageSettingWidget from './component/StylePageSettingWidget'
import {parseUrl} from '../../../utils/UrlFormat'
import EntEditWidget from '../../../components/common/EntEditWidget'
import PicChooseWidget from './component/PicChooseWidget'
import {handleSimpleDownload} from '../../../utils/filedown'
import SharePageSettingWidget from './component/SharePageSettingWidget'

export default {
  name: 'ProductPageList',
  components: {
    SharePageSettingWidget,
    PicChooseWidget, EntEditWidget, StylePageSettingWidget, UpLoadImage, BasePageComponent
  },
  data () {
    return {
      showStyleSet: false,                      //风格设置
      showQrCode: false,                        //显示企业码
      shareModal: false,                        //编辑页面分享
      renameModal: {                            //导航重命名
        show: false,
        title: '重置名称',
        name: '',
        nameColor: '',
        nameSelectedColor: '',
        fontSize: 28,
        row: {},
      },
      companyModal: {
        show: false,
      },
      columns: [
        {
          title: '页面名称',
          key: 'name',
          width: 100,
          align: 'left',
        }, {
          title: '选前图标',
          width: 90,
          align: 'center',
          slot: 'dIcon'
        }, {
          title: '选中图标',
          width: 90,
          align: 'center',
          slot: 'sIcon'
        }, {
          title: '更新时间',
          key: 'updatetime',
          align: 'center',
          width: 170
        }, {
          title: '状态',
          slot: 'status',
          align: 'left',
          minWidth: 180
          // }, {
          //   title: '导航链接',
          //   align: 'left',
          //   tooltip: true,
          //   minWidth: 200,
          //   key: 'linkurl'
          // }, {
          //   title: '复制',
          //   slot: 'copy',
          //   width: 70,
          //   align: 'left'
        }, {
          title: '操作',
          slot: 'operation',
          align: 'left',
          width: 540
        }
      ],
      entInfo: {
        logo: '',
        entName: '',
        contact: '',
        phone: '',
        superName: '',
        webPage: ''
      },
      showPicChoose: false,                //选择图标
      selectData: null,
      editPicData: {
        iconSelUrl: '',
        iconUrl: ''
      },
      editShareData: {
        editPageId: 0,
        shareCover: '',
        shareTitle: '',
      },
      editStyleData: {
        editPageId: 0,
        pageName: '',
        customColor: '#F8F8F9',
        textColor: '#333333',
        titleBgColor: 'white',
        logoWidth: 0,
        logoHeight: 0,
        bgPicWidth: 0,
        bgPicHeight: 0,

        showTitle: 0,
        logo: '',
        bgPic: '',
        buttonUrl: ''
      }
    }
  },
  computed: {
    getQrCode () {
      return this.$store.state.company.switchEntQrcodeUrl || ''
    },
    getBarData () {
      return this.$store.state.navigation.buttombarData.filter(res => {
        return res.type === 7 || res.type === 8 || res.type === 9 || res.type === 10
      }).map(res => {
        let jumpUrl = res.jumpLink ? res.jumpLink.link || '' : ''
        let pageId = 0
        if (jumpUrl) {
          let objurl = parseUrl(jumpUrl)
          pageId = parseInt(objurl.id)
        }
        let linkurl = res.link ? res.link.link || '' : ''
        let page = res.page
        let style = JSON.parse(res.style)
        return {
          id: res.id || 0,
          pageId: pageId,
          name: res.name || '',
          iconUrl: res.icon || '',
          iconSelUrl: res.selectedIcon || '',
          iconId: res.iconId || 0,
          selectedIconId: res.selectedIconId || 0,
          isDefault: res.isHome || 0,
          type: res.type,
          jumpUrl: jumpUrl || '',
          linkurl: linkurl || '',
          updatetime: res.updateTime || '',
          status: res.isEnable || 0,
          nameColor: style ? style.nameColor || '#000000' : '#000000',
          nameSelectedColor: style ? style.nameSelectedColor || '#FF720B' : '#FF720B',
          fontSize: style ? style.fontSize || 28 : 28,
          sort: res.sort,
          page: res.page,
          share: {
            shareTitle: page ? page.shareTitle || '' : '',
            shareCover: page ? page.shareCover || '' : ''
          },
        }
      })
    },
    getEntname () {
      return this.$store.state.company.entName || ''
    },
    getEntLogo () {
      return this.$store.state.company.entLogo || require('../../../assets/common/icon_logo.png')
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.init()
  },
  methods: {
    init () {
      this.getEntNavigations()
      // this.getCurrentEntInfo()
    },
    getUnableStatus (row, index) {
      if (row.type !== 5) {
        return '#3B80FF'
      } else {
        return '#BBBBBB'
      }
    },
    getStatus (row) {
      if (row.status === 1) {
        return 'red'
      } else {
        return 'green'
      }
    },
    // uploadDefaultImageSuccess (data, index) {
    //   if (data && data.length) {
    //     this.dataList[index].iconUrl = data[0].url
    //   }
    // },
    // uploadSelectClassImageSuccess (data, index) {
    //   if (data && data.length) {
    //     this.dataList[index].iconSelUrl = data[0].url
    //   }
    // },
    onPageRenovationClick (row) {
      var from = 'HomePage'
      if (row.type === 5) {
        // from = 'Mine'
        return
      }
      const {href} = this.$router.resolve({
        path: '/renovation',
        query: {
          id: row.pageId,
          title: row.name,
          from: from,
          tagTitle: row.name + '装修'
        }
      })
      // window.open(href, 'page' + row.id)
      this.$router.push(href)
    },
    onShareSettingClick (row, index) {                     //点击分享设置
      if (row.type === 5) {
        return
      }
      this.editShareData = {
        editPageId: row.pageId,
        shareCover: row.share.shareCover || '',
        shareTitle: row.share.shareTitle || '',
      }
      this.shareModal = true
    },
    onShareConfigOK () {
      this.getEntNavigations()
      this.shareModal = false
    },
    onRenameClick (row) {                         //重置名称
      this.renameModal = {
        show: true,
        name: row.name,
        nameColor: row.nameColor || '#000000',
        nameSelectedColor: row.nameSelectedColor || '#FF720B',
        fontSize: row.fontSize || 28,
        row: row,
      }
    },
    onStylePageOK () {
      this.getEntNavigations()
      this.showStyleSet = false
    },
    renameModalCancel () {                        //重置名称 确认
      this.renameModal.show = false
    },
    renameModalOk () {                            ////重置名称 取消
      if (!this.renameModal.name) {
        this.$Message.info('名称不能为空')
        return
      }
      let style = JSON.stringify({
        nameColor: this.renameModal.nameColor || '#000000',
        nameSelectedColor: this.renameModal.nameSelectedColor || '#FF720B',
        circulSelectedColor: 'white',
        hasCircularBg: 0,
        showText: 1,
        showIcon: 0,
        fontSize: this.renameModal.fontSize,
        isMineHidden: 0
      })
      let params = {
        id: this.renameModal.row.id,
        name: this.renameModal.name,
        style: style,
      }
      this.updateNavItem(params).then(res => {
        if (res.code === 0) {
          this.getEntNavigations()
          this.renameModal.show = false
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },

    changeStatus (row, index) {
      const operator = row.status === 1 ? '停用' : '发布'
      var page = row.name
      this.$Modal
        .confirm({
          title: '提示',
          content: '确定要' + operator + '页面 ' + page + ' 吗?',
          onOk: () => {
            let list = this.getBarData
            let params = {
              id: list[index].id,
              isEnable: list[index].status === 1 ? 0 : 1
            }
            this.updateNavItem(params).then(res => {
              if (res.code === 0) {
                this.getEntNavigations()
              }
              if (res.msg) {
                this.$Message.info(res.msg)
              }
            })


          },
          onCancel: () => {
          }
        })
    },
    //设置默认页
    setDefaultPage (row, index) {
      if (row.type === 5) {
        return
      }
      this.setNavHome(row.id).then(res => {
        if (res.code === 0) {
          this.getEntNavigations()
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },

    onStyleSettingClick (row) {
      if (row.type !== 5) {
        if (row.page) {
          let pageName = row.page.title || ''
          let style = row.page.style ? JSON.parse(row.page.style) : null
          let customColor = style ? style.pageBgColor || '#F8F8F9' : '#F8F8F9'
          let textColor = style ? style.navTitleColor || '#333333' : '#333333'
          let titleBgColor = style ? style.navBgColor || 'white' : 'white'
          let logoWidth = style ? style.logoWidth || 0 : 0
          let logoHeight = style ? style.logoHeight || 0 : 0

          let bgPicWidth = style ? style.pageBgImgWidth || 0 : 0
          let bgPicHeight = style ? style.pageBgImgHeight || 0 : 0
          let extension = row.page.extension ? JSON.parse(row.page.extension) : null
          let showTitle = extension ? extension.showNav || 0 : 0
          let buttonUrl = extension ? extension.buttonUrl || '' : ''

          let logo = extension ? extension.logo || '' : ''
          let bgPic = extension ? extension.pageBgImg || '' : ''
          this.editStyleData = {
            editPageId: row.pageId || 0,
            pageName: pageName || '',
            customColor: customColor || '#F8F8F9',
            textColor: textColor || '#333333',
            titleBgColor: titleBgColor || 'white',
            logoWidth: logoWidth || 0,
            logoHeight: logoHeight || 0,
            bgPicWidth: bgPicWidth || 0,
            bgPicHeight: bgPicHeight || 0,

            showTitle: showTitle || 0,
            logo: logo || '',
            bgPic: bgPic || '',
            buttonUrl: buttonUrl || ''
          }
        }
        this.showStyleSet = true
      }
    },
    onModalClose (status) {
      if (!status) {
        this.editShareData = {
          editPageId: 0,
          shareCover: '',
          shareTitle: '',
        }
        this.editStyleData = {
          editPageId: 0,
          pageName: '',
          customColor: '#F8F8F9',
          textColor: '#333333',
          titleBgColor: 'white',
          logoWidth: 0,
          logoHeight: 0,
          bgPicWidth: 0,
          bgPicHeight: 0,

          showTitle: 0,
          logo: '',
          bgPic: '',
          buttonUrl: ''
        }
      }
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    onAccountEdit () {
      let company = this.$store.state.company
      let entName = company.entName || ''
      let logo = company.entLogo || ''
      let contact = ''
      let phone = ''
      this.entInfo = {
        logo,
        entName,
        contact,
        phone,
        superName: '张三',
        webPage: 'http://www.so.laodao.cn'
      }
      this.companyModal.show = true
    },
    onIconOKClick () {
      this.getEntNavigations()
      this.showPicChoose = false
    },
    onPicChooseClick (row) {
      this.selectData = row
      this.editPicData = JSON.parse(JSON.stringify(row))
      this.showPicChoose = true
    },
    getUpItemColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#3B80FF'
      }
    },
    getDownItemColor (index) {
      if ((this.getBarData.length - 1) === index) {
        return '#BBBBBB'
      } else {
        return '#3B80FF'
      }
    },
    onQrcodeDownload () {
      if (this.getQrCode) {
        handleSimpleDownload(this.getQrCode)
      }
    },
    ...mapActions([
      'getEntNavigations',
      'updateNavItem',
      'getCurrentEntInfo',
      'setNavHome',
      'setNavSort'
    ])
  },
}
</script>

<style lang="scss" scoped>
  .modal-setting ::v-deep {


    //.ivu-modal {
    //  display: flex;
    //  align-items: center;
    //  justify-content: center;
    //  top: 200px;
    //}

    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }


  .modal-setting2 ::v-deep {
    .ivu-modal-header {
      display: none;
    }
  }


</style>
<style scoped>
  .modals >>> .ivu-modal-body {
    padding: 0;
  }

  .tablePtye >>> .ivu-table-cell {
    padding-left: 5px;
    padding-right: 5px;
  }

  /*.modals >>> .ivu-modal-content {*/
  /*border-bottom-left-radius: 0px;*/
  /*border-bottom-right-radius: 0px;*/
  /*}*/
</style>
